<template>
  <nav class="patient-nav">
    <router-link
      v-for="item in items"
      :key="item.to"
      :to="item.to"
      :class="isActive(item.to)"
      @click="$emit('navigate')"
    >
      <i :class="item.icon"></i>
      {{ item.label }}
    </router-link>
    <a href="#" @click.prevent="$emit('logout')">
      <i class="uil uil-sign-out-alt"></i>
      Sair
    </a>
  </nav>
</template>

<script>
export default {
  name: "PatientNav",
  emits: ["navigate", "logout"],
  computed: {
    items() {
      return [
        { to: "/schedules", icon: "uil uil-calendar-alt", label: "Agendamentos" },
        { to: "/history", icon: "uil uil-history", label: "Histórico" },
        { to: "/exams", icon: "fas fa-notes-medical", label: "Exames" },
        { to: "/prescriptions", icon: "fas fa-file-medical-alt", label: "Receitas" },
        { to: "/documents", icon: "fas fa-file-medical", label: "Documentos" },
        { to: "/patients", icon: "uil uil-users-alt", label: "Pacientes" },
        { to: "/profile", icon: "uil uil-setting", label: "Perfil" },
      ];
    },
  },
  methods: {
    isActive(path) {
      return this.$router.currentRoute.value.fullPath === path ? "active" : "";
    },
  },
};
</script>
